import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

import Sidebar from "~/components/Sidebar/Sidebar.tsx";
import type { QuotaWithRelations } from "~/modules/quota/api/quota/quotaTypes.ts";
import {
	AttachQuotaInvoicesForm,
} from "~/modules/quota/components/QuotaDetailsView/components/AttachQuotaInvoicesSidebar/AttachQuotaInvoicesForm.tsx";
import { invalidateQuotaInvoiceChangeQueries } from "~/modules/quota/utils/quotaCacheUtils.ts";

type Props = {
	isOpen: boolean;
	onClose: () => void;
	quota: QuotaWithRelations;
};

export const AttachQuotaInvoicesSidebar = ({ isOpen, onClose, quota }: Props) => {
	const queryClient = useQueryClient();

	const handleSuccess = useCallback(async () => {
		await invalidateQuotaInvoiceChangeQueries(queryClient, quota);
		onClose();
	}, [onClose, queryClient, quota]);

	return (
		<Sidebar closeOnOutsideClick={false}
				 open={isOpen}
				 width="xl"
				 setOpen={onClose}>
			{isOpen && <AttachQuotaInvoicesForm onCancel={onClose}
												onSuccess={handleSuccess}
												quota={quota} />}
		</Sidebar>
	);
};
